import {defineStore} from "pinia";
import axios from "@/utils/axios.js";

const pendingRefreshes = new WeakMap();

export const useActiveCoupon = defineStore("activeCoupon", {
  state: () => ({
    coupon: null,
    requestId: 0,
    ready: false,
  }),
  actions: {
    clear() {
      this.requestId += 1;
      this.coupon = null;
      this.ready = true;
      pendingRefreshes.delete(this);
    },
    async refresh(authenticated = true) {
      if (!authenticated) {
        this.clear();
        return;
      }

      const pending = pendingRefreshes.get(this);
      if (pending) return pending;

      const requestId = ++this.requestId;
      const refresh = (async () => {
        await Promise.resolve();
        try {
          const {data} = await axios.get("/api/v1/coupon/active");
          if (requestId === this.requestId) {
            this.coupon = data.active_coupon || null;
            this.ready = true;
          }
        } catch {
          if (requestId === this.requestId) {
            this.coupon = null;
            this.ready = true;
          }
        } finally {
          if (pendingRefreshes.get(this) === refresh) pendingRefreshes.delete(this);
        }
      })();
      pendingRefreshes.set(this, refresh);
      return refresh;
    },
  },
});
